var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"766a36c99091cffc994db925d8fd2e397741a04a"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import { init } from '@sentry/nextjs';
import { env } from 'env.mjs';

import packageJson from './package.json';

const SENTRY_DSN = env.NEXT_PUBLIC_SENTRY_DSN;
const ENVIRONMENT = env.NEXT_PUBLIC_ENVIRONMENT;

init({
  dsn: SENTRY_DSN,
  tracesSampleRate: 1,
  debug: false,
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: ENVIRONMENT !== 'production' ? 0.1 : 1.0,
  release: `govco-frontent@${packageJson.version}`,
  environment: ENVIRONMENT,
  enabled: ENVIRONMENT === 'production',
});
